import { css } from '@emotion/react'
import common from 'shared/styles'

const styles = () => {
    return {
        reader: css`
            display: flex;
            justify-content: center;
            align-items: center;
        `,
        actions: css`
            ${common.flexJustityAlignCenter};
            flex-direction: column;
            padding: 0;
        `,
        button: css`
            width: auto;
            padding: 40px 0;
        `,
        icon: css`
            width: 50px;
            height: 50px;
        `,
    }
}

export default styles
